export default __webpack_public_path__ + "static/media/craon7.d12f47a9.jpg";